<template>
    <div>
        <button @click="show = !show" type="button" data-modal-target="crypto-modal" data-modal-toggle="crypto-modal" class="w-full px-4 py-2 font-semibold text-center text-white uppercase bg-blue-500 rounded-md">
            BOOK NOW
        </button>
        <!-- Main modal -->
        <div v-if="show" id="crypto-modal" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 flex flex-col items-center bg-blue-500 justify-center bg-opacity-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
            <div class="relative w-full max-w-3xl max-h-full">
                <!-- Modal content -->
                <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
                    <button @click="show = !show" type="button" class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="crypto-modal">
                        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                        </svg>
                    </button>
                    <!-- Modal header -->
                    <div class="px-6 py-4 border-b rounded-t dark:border-gray-600">
                        <h3 class="text-base font-semibold text-gray-900 lg:text-xl dark:text-white">
                            Book Event Now
                        </h3>
                    </div>
                    <!-- Modal body -->
                    <div class="p-6">
                        <div class="flex">
                            <!-- <button @click="changeMode('stripe')" :class="setMode === 'stripe' ? 'text-white bg-pink-500' : ' text-pink-500 border border-pink-500'" class="w-full p-3 text-sm font-semibold tracking-wide text-center">Stripe</button>
                            <button @click="changeMode('paypal')" :class="setMode === 'paypal' ? 'text-white bg-pink-500' : 'text-pink-500 border-pink-500 border'" class="w-full p-3 text-sm font-semibold tracking-wide text-center">Paypal</button> -->
                            <button @click="changeMode('bank-transfer')" :class="setMode === 'bank-transfer' ? 'text-white bg-pink-500' : 'text-pink-500 border-pink-500 border'" class="w-full p-3 text-sm font-semibold tracking-wide text-center">Trasferimento Bancario</button>
                        </div>
                        <div class="my-4 space-y-3">
                            <!-- <div v-show="setMode === 'stripe'" class="my-6">
                                <StripePayment :reservationData="formData" :event="event" mode="stripe"></StripePayment>
                            </div>
                            <div v-show="setMode === 'paypal'">
                                <PayPalPayment :event="event" :reservationData="formData" mode="paypal"></PayPalPayment>
                            </div> -->
                            <div v-show="setMode === 'bank-transfer'">
                                <BankTransferPayment :event="event" :reservationData="formData" mode="bank-transfer"></BankTransferPayment>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import StripePayment from '../gateway/StripePayment.vue';
import PayPalPayment from '../gateway/PayPalPayment.vue';
import BankTransferPayment from '../gateway/BankTransferPayment.vue';

export default {
    props: ['event', 'formData'],
    components: {
        StripePayment,
        PayPalPayment,
        BankTransferPayment
    },
    data(){
        return {
            show: false,
            setMode: 'stripe',
        }
    },
    methods: {
        changeMode(value) {
            this.setMode = value;
        }
    }
}
</script>